/**
 * Where the member was before they went to buy coins.
 *
 * Buying is never the thing someone came to do — it interrupts asking someone
 * out, unlocking a chat, or looking through profiles. Stripe returns to
 * /app/coins and that is where the journey ended: a green banner for four
 * seconds, then a price list, and no way back to the person they were buying
 * the coins for.
 *
 * Recorded by the /app shell on every navigation, read by the purchase-success
 * sheet. sessionStorage, so it dies with the tab and never leaks between
 * members on a shared device.
 */
const KEY = "ohlala_last_browse_path_v1";

/** Paths that are never somewhere to "go back to" after a purchase. */
const SKIP = ["/app/coins", "/auth", "/login", "/register", "/onboarding"];

export function recordBrowsePath(path: string): void {
  if (!path || SKIP.some((p) => path.startsWith(p))) return;
  try {
    sessionStorage.setItem(KEY, path);
  } catch {
    /* private mode / storage disabled — the fallback covers it */
  }
}

/** The last real screen, or `/app/search` when there isn't one. */
export function readBrowsePath(): string {
  try {
    const v = sessionStorage.getItem(KEY);
    if (v && v.startsWith("/app/") && !SKIP.some((p) => v.startsWith(p))) return v;
  } catch {
    /* ignore */
  }
  return "/app/search";
}
